<template>
<panel collapsible>
    <p slot="header">
        Filtry
    </p>
    <ui-textbox label="E-mail" name="name" type="text" v-model="name" @input="filter" placeholder="Wpisz część adresu e-mail"></ui-textbox>

    <i-select name="groups" label="Grupy" v-model="groups_ids" :options="groups" placeholder="Wybierz" @input="filter" help-text="E-maile które występują w przynajmniej jednej z zaznaczonych grup"></i-select>

    <i-select name="status" label="Status" v-model="status" :options="statuses" placeholder="Wybierz status" @input="filter" ></i-select>



    <ui-button @click="filter">Filtruj</ui-button>
    <ui-button @click="removeFilter">Usuń filtry</ui-button>
</panel>

</template>
<script>
import Utils from './../../services/Utils'
import EmailGroups from './../../services/EmailGroups'

export default {
  data () {
    return {
      name: '',

      groups_ids: [],
      groups: [],
      groups_default: [],

      status: null,
      status_se: null,
      status_default: null,
      statuses: [{name: 'Potwierdzone', id: 1}, {name: 'Niepotwierdzone', id: 0}, {name: 'Usunięte', id: 2}],

      keysForSelect: Utils.keysForSelect()
    }
  },
  mounted () {
    EmailGroups.names().then(res => {
      this.groups = res.data.items
    })
  },
  methods: {
    getFilters () {
      let filters = {
        name: this.name,
        groups_ids: this.groups_ids,
        status: this.status
      }

      return filters
    },
    filter () {
      this.$emit('filter', this.getFilters())
    },
    removeFilter () {
      this.name = ''
      this.groups_ids = []
      this.status = null
      this.was_imported = false
      this.$emit('filter', this.getFilters())
    }
  }
}
</script>



// WEBPACK FOOTER //
// Filters.vue?78f41c49